// © Microsoft Corporation. All rights reserved.

export enum Market {
    BR = "pt-br",
    DEDE = "de-de",
    ENCA = "en-ca",
    ENGB = "en-gb",
    ENUS = "en-us",
    ESMX = "es-mx",
    FRCA = "fr-ca",
    FRFR = "fr-fr",
    IN = "en-in",
    JAJP = "ja-jp",
    PTBR = "pt-br",
    KOKR = "ko-kr",
    ZHCN = "zh-cn"
}